import React, { useRef } from 'react'
import { resolveIconNode } from '../icons'

export function SettingsCard({ title, subtitle, children, footer }) {
  return (
    <div className="portal-settings-card">
      {(title || subtitle) && (
        <div className="portal-settings-card-header">
          <div>
            {title && <span className="portal-settings-card-title">{title}</span>}
            {subtitle && <span className="portal-settings-card-sub">{subtitle}</span>}
          </div>
        </div>
      )}
      <div className="portal-settings-card-body">{children}</div>
      {footer}
    </div>
  )
}

export function SettingsToggle({ icon, iconClass = 'blue', name, desc, checked, onChange }) {
  return (
    <div className="portal-toggle-row">
      <div className="portal-toggle-left">
        <div className={`portal-toggle-icon ${iconClass}`}>{resolveIconNode(icon, { size: 'sm' })}</div>
        <div className="portal-toggle-info">
          <div className="portal-toggle-name">{name}</div>
          {desc && <div className="portal-toggle-desc">{desc}</div>}
        </div>
      </div>
      <label className="portal-toggle-switch">
        <input type="checkbox" checked={checked} onChange={(e) => onChange?.(e.target.checked)} />
        <span className="portal-toggle-slider" />
      </label>
    </div>
  )
}

export function SettingsAvatar({ name, avatarUrl, onUpload, onRemove, uploading }) {
  const fileRef = useRef(null)
  const initial = name?.charAt(0)?.toUpperCase() || 'U'

  const handleFileChange = async (e) => {
    const file = e.target.files?.[0]
    e.target.value = ''
    if (file && onUpload) await onUpload(file)
  }

  return (
    <div className="portal-avatar-upload">
      <div className="portal-avatar-preview">
        {avatarUrl ? (
          <img src={avatarUrl} alt="" className="portal-avatar-img" />
        ) : (
          initial
        )}
      </div>
      <div className="portal-avatar-actions">
        <input
          ref={fileRef}
          type="file"
          accept="image/jpeg,image/png,.jpg,.jpeg,.png"
          hidden
          onChange={handleFileChange}
        />
        <button
          type="button"
          className="portal-avatar-btn primary"
          disabled={uploading}
          onClick={() => fileRef.current?.click()}
        >
          {uploading ? 'Uploading…' : 'Upload Photo'}
        </button>
        <button
          type="button"
          className="portal-avatar-btn"
          disabled={uploading || !avatarUrl}
          onClick={onRemove}
        >
          Remove
        </button>
        <span className="portal-avatar-hint">JPG, PNG · Max 5MB · 1:1 ratio recommended</span>
      </div>
    </div>
  )
}

export function SettingsBtnGroup({ children }) {
  return <div className="portal-settings-btn-group">{children}</div>
}
